import React from 'react';

import { ProgramType } from 'fitbeat.models';
import LeanAndFitIcon from '../../../assets/icons/lean-and-fit.svg';
import MobilityAndToneIcon from '../../../assets/icons/mobility-and-tone.svg';
import MuscleAndShredIcon from '../../../assets/icons/muscle-and-shred.svg';
import MuscleAndStrengthIcon from '../../../assets/icons/muscle-and-strength.svg';
import StrongAndFitIcon from '../../../assets/icons/strong-and-fit.svg';

import Theme from '../../../theme';

interface IProps {
  goal: ProgramType;
  color?: string;
  styles?: React.CSSProperties;
}

export const GoalIcon = ({
  color = Theme.BLACK,
  goal,
  styles,
}: IProps) => {
  const goalIcons: { [goal: string]: JSX.Element } = {
    [ProgramType.GetStrongAndFitGoal]: <StrongAndFitIcon width='100%' height='100%' style={styles} fill={color} />,
    [ProgramType.GetLeanAndFitGoal]: <LeanAndFitIcon width='100%' height='100%' style={styles} fill={color} />,
    [ProgramType.MobilityAndTone]: <MobilityAndToneIcon width='100%' height='100%' style={styles} stroke={color} />,
    [ProgramType.GainMuscleAndStrengthGoal]: (
      <MuscleAndStrengthIcon width='100%' height='100%' style={styles} fill={color} />
    ),
    [ProgramType.MuscleAndShred]: <MuscleAndShredIcon width='100%' height='100%' style={styles} stroke={color} />,
  };

  return goalIcons[goal];
};
